// OP-2 (PR 56 open points, 22-Oct) — "Pre-fill from 203(a)" never puts one control in two cycles: the 203(a) rows whose
// control already has a walkthrough in another cycle are listed on the cycle with "Move here". EN + AR.
export const I18N_OP2 = {
  en: {
    op2: {
      skippedTitle: "Already in another cycle — not added again",
      skippedHint: "These 203(a) controls already have a walkthrough in another cycle. Move here moves that walkthrough with its evidence; nothing moves without the click.",
      alreadyIn: "already in {cycle}",
      moveHere: "Move here",
      moved: "Moved to {cycle} as {ref}",
      skippedToast: "{n} control(s) already in another cycle: not added again (see the list in this cycle)",
    },
  },
  ar: {
    op2: {
      skippedTitle: "موجودة في دورة أخرى — لم تُضف مرة ثانية",
      skippedHint: "لضوابط ⁨203(a)⁩ هذه اختبار تتبع في دورة أخرى. «انقل إلى هنا» ينقل اختبار التتبع مع أدلته؛ لا يُنقل شيء دون النقر.",
      alreadyIn: "موجود بالفعل في {cycle}",
      moveHere: "انقل إلى هنا",
      moved: "تم النقل إلى {cycle} برقم {ref}",
      skippedToast: "{n} ضابط/ضوابط موجودة في دورة أخرى: لم تُضف مرة ثانية (انظر القائمة في هذه الدورة)",
    },
  },
};

export default I18N_OP2;
